import { CustomersApiRemoteService } from '../../Services/api/customers/customers-service'
import {  IUpdateCustomerPayload } from '../../Services/api/customers/customers.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdateCustomersUseCase
implements IFormUsecase<IUpdateCustomerPayload, void> {
  constructor (private readonly CustomersApi: CustomersApiRemoteService) {}
    

  public async handle (
    data: IUpdateCustomerPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CustomersApi.update(data)

      if (response.isFailure) {
        return response
      }
    
      
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
